import { useSearchParams } from "react-router-dom";
import { ChartLineUp, Desktop, Info } from "@phosphor-icons/react";
import PageHeader from "../../components/layout/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import EssMyActivity from "./EssMyActivity";
import EssMyDesktopActivity from "./EssMyDesktopActivity";

const SOURCES = {
    overall: "Combined from your check-in / check-out and breaks, the REEDOS web app while it is open, and the desktop agent: logged-in, active, idle and break time.",
    desktop: "Only from the REEDOS desktop agent installed on your computer: device status, active, idle and locked time.",
};

function SourceNote({ tab }) {
    return (
        <div className="mt-3 flex items-start gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-700" data-testid={`my-activity-source-${tab}`}>
            <Info size={14} className="mt-0.5 shrink-0 text-slate-500" />
            <span>{SOURCES[tab]} The two views are measured differently, so their numbers can differ.</span>
        </div>
    );
}

export default function MyActivityPage() {
    const [params, setParams] = useSearchParams();
    const tab = params.get("tab") === "desktop" ? "desktop" : "overall";
    const pick = (v) => setParams(v === "desktop" ? { tab: "desktop" } : {}, { replace: true });
    return (
        <div data-testid="my-activity-page">
            <PageHeader eyebrow="My Workspace" title="My Activity" description="Your own activity, private to you: your overall day, or the desktop agent on its own." />
            <div className="px-6 sm:px-8 py-5">
                <Tabs value={tab} onValueChange={pick}>
                    <TabsList data-testid="my-activity-source-tabs">
                        <TabsTrigger value="overall" data-testid="my-activity-tab-overall"><ChartLineUp size={14} className="mr-1.5" /> Overall activity</TabsTrigger>
                        <TabsTrigger value="desktop" data-testid="my-activity-tab-desktop"><Desktop size={14} className="mr-1.5" /> Desktop agent</TabsTrigger>
                    </TabsList>
                    <SourceNote tab={tab} />
                    <TabsContent value="overall" className="mt-0"><EssMyActivity embedded /></TabsContent>
                    <TabsContent value="desktop" className="mt-0"><EssMyDesktopActivity embedded /></TabsContent>
                </Tabs>
            </div>
        </div>
    );
}
